import * as React from 'react';
import { memo, useEffect } from 'react';
import { ContentRenderMode } from "../enums.ts";
import { isFunction, isObject } from "../helpers/utils.ts";
import type { PageRenderedSectionData, PageSectionData } from "../page/content.types.ts";
import RenderSection from "./renderSection";

type Props = Readonly<{
	content?: PageSectionData[],
	mode?: ContentRenderMode
}>

declare global {
	interface Window { initializeCmsContent: Function[]; }
}

function RenderContent({content, mode = ContentRenderMode.NORMAL}: Props) {
	useEffect(() => {
		console.log(isObject(globalThis?.initializeCmsContent));
		if (isObject(globalThis?.initializeCmsContent)) {
			Object.keys(globalThis.initializeCmsContent).forEach((key) => {
				const func = globalThis.initializeCmsContent[key];
				if (isFunction(func)) {
					func();
				}
			});
		}
	}, [content]);

	return (<>
		{content && Array.isArray(content) && content.map((section: PageRenderedSectionData, index) => {
			if (section?.reusable) { // non reusable renders normal sections
				return <RenderContent key={'section' + index} content={section?.page?.content} mode={ContentRenderMode.REUSE_SECTION}/>;
			}

			// previously it was needed to ignore reusable sections to avoid infinite loop
			// mode !== ContentRenderMode.REUSE && mode !== ContentRenderMode.REUSE_BLOCK
			return <RenderSection key={'section' + index} section={section} indexSection={index} mode={mode}/>;
		})}
	</>);
}

export default memo(RenderContent);
